import { render, staticRenderFns } from "./BaseSignature.vue?vue&type=template&id=ca636d0e"
import script from "./BaseSignature.vue?vue&type=script&lang=js"
export * from "./BaseSignature.vue?vue&type=script&lang=js"
import style0 from "./BaseSignature.vue?vue&type=style&index=0&id=ca636d0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports